export function hasAnyFeatureAccess({
  uagEnhancements,
  featurePermissions,
  userFeaturePermissions,
}) {
  const legacyPermissions = featurePermissions ?? {}
  const uagPermissions = userFeaturePermissions ?? {}

  return uagEnhancements
    ? Object.values(uagPermissions).some((feature) => Object.values(feature ?? {}).some(Boolean))
    : Object.values(legacyPermissions).some(Boolean)
}
